let TextHelper = {
    nl2br: function (str, is_xhtml) {
        if (typeof str === "undefined" || str === null) {
            return "";
        }
        var breakTag =
            is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
        return (str + "").replace(
            /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
            "$1" + breakTag + "$2",
        );
    }
};
export default TextHelper;
